import { FilterOperator, IFilterCriteria } from '..';

export enum CoffeeLeadIssueCategory {
	WrongLocationOrTimeZone = 'WrongLocationOrTimeZone',
	Duplicate = 'Duplicate',
	CurrentClientNeedsAttention = 'CurrentClientNeedsAttention',
	Other = 'Other',
}

export enum CoffeeLeadIssueFilterCriteriaProperty {
	CreationDate = 'CreationDate',
	Category = 'Category',
	User = 'User',
	IsComplete = 'IsComplete',
	CompanyId = 'CompanyId',
}

export type ICoffeeLeadIssueFilter = IFilterCriteria<CoffeeLeadIssueFilterCriteriaProperty, FilterOperator>;

export interface ICoffeeLeadIssueUserReference {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	profilePic?: string;
}

export interface ICoffeeLeadIssueView {
	id: string;
	category: CoffeeLeadIssueCategory;
	description: string;
	companyId: string;
	companyName?: string;
	reporter?: ICoffeeLeadIssueUserReference;
	creationDate: string;
	completionDate?: string;
	completedBy?: ICoffeeLeadIssueUserReference;
}

export interface ICreateCoffeeLeadIssueRequest {
	category: CoffeeLeadIssueCategory;
	description: string;
	companyId: string;
}
